import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
import { ref, onMounted } from "vue";
import HomePage from "./views/HomePage.vue";
import axios from "axios";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const locationPermissionGranted = ref(false);
        const locationPermissionDenied = ref(false);
        const location = ref(null);
        const address = ref(null);
        function requestLocationPermission() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(async (position) => {
                    locationPermissionGranted.value = true;
                    locationPermissionDenied.value = false;
                    location.value = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    };
                    await getAddressFromLocation();
                }, (error) => {
                    if (error.code === error.PERMISSION_DENIED) {
                        console.error("Location access denied by user.");
                        locationPermissionGranted.value = false;
                        locationPermissionDenied.value = true;
                    }
                    else {
                        console.error("Error occurred while retrieving location:", error);
                    }
                }, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0,
                });
            }
            else {
                console.error("Geolocation is not supported by this browser.");
                locationPermissionGranted.value = false;
                locationPermissionDenied.value = true;
            }
        }
        async function getAddressFromLocation() {
            try {
                const apiKey = "AIzaSyA3-6MGuTtN24nw6KOm9KSPONVbeENsIZc"; // Ensure this API key is valid
                if (location.value) {
                    const { latitude, longitude } = location.value;
                    const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
                        params: {
                            latlng: `${latitude},${longitude}`,
                            key: apiKey,
                        },
                    });
                    if (response.data.status === "OK" && response.data.results.length > 0) {
                        const firstResult = response.data.results[0];
                        address.value = firstResult.formatted_address;
                    }
                    else {
                        console.error("Failed to get address:", response.data.status);
                    }
                }
            }
            catch (error) {
                console.error("Error fetching address:", error);
            }
        }
        function promptForLocation() {
            if (!locationPermissionGranted.value && !locationPermissionDenied.value) {
                requestLocationPermission();
            }
        }
        onMounted(() => {
            promptForLocation();
        });
        return (_ctx, _cache) => {
            return (locationPermissionGranted.value && location.value && address.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(HomePage, {
                        location: location.value,
                        address: address.value
                    }, null, 8, ["location", "address"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
